<style>
    .report-form-step .form-check {
        margin-left: 0;
        padding-left: 0;
        margin-bottom: 20px;
    }
    .report-form-step label {
        display: block;
        padding-left: 15px;
        text-indent: -15px;
        line-height: 100%;
    }
    #main_content .form-group .report-form-step input {
        width: 13px;
        height: 13px;
        padding: .375rem 10px;
        margin:0;
        /* vertical-align: bottom; */
        position: relative;
        top: -1px;
        overflow: hidden;
    }
    .text-18px {
        font-size: 18px
    }
    .run-ready {
        font-size: 20px;
        font-weight: normal;
        line-height: 1.66;
    }
    .run-instructions {
        font-size: 15px;
        font-weight: normal;
        line-height: 1.66;
    }
    .report-form-step .vdp-datepicker__calendar {
        left: -250px;
        top: 20px;
    }
</style>

<template>
    <div class="report-form">
        <div role="tablist">
            <form-step class="report-form-step" :step-state="steps[1]" v-on:next="goForward()" v-on:headerclick="selectStepDirectly(1)" :previousButton="false">
                <template #title>1. Choose Type of Report</template>
                <template #content>
                    <div class="report-types container-fluid">
                        <div class="row">
                            <div v-for="type in reportTypes" :key="type.id" class="form-check mx-0 pl-0 col-sm-6">
                                <label class="text-medium-blue text-18px">
                                    <input type="radio" v-model="report_type_id" :value="type.id" />
                                    <strong>{{type.name}}</strong>
                                </label>
                            </div>
                        </div>
                    </div>
                </template>
                <template #summary>
                    {{ (report_type_id) ? reportTypes.find((item) => item.id == report_type_id ).name : null }}
                </template>
            </form-step>
            <form-step class="report-form-step" v-on:next="goForward()" v-on:previous="selectStep(1)" :step-state="steps[2]" v-on:headerclick="selectStepDirectly(2)" style="z-index: 1000">
                <template #title>2. Choose Report Options</template>
                <template #content>
                    <div v-if="(auth.is('site-admin') || auth.is('super-user')) && report_type_id != 3" class="mb-3 pb-3 border-bottom">
                        <label for="state_id">State</label>
                        <div class="form-group form-inline">
                            <select v-model="selectedState" class="width-auto">
                                <option :value="{}">All States</option>
                                <option v-for="st in states" :key="st.id" :value="st">{{st.name}}</option>
                            </select>
                        </div>
                    </div>
                    <div v-if="auth.is('partner-user') && report_type_id != 3" class="mb-3 pb-3 border-bottom">
                        <label for="state_id">County</label>
                        <div class="form-group form-inline">
                            <select v-model="selectedCounty" class="width-auto">
                                <option>All Counties</option>
                                <option v-for="county in counties" :key="county.id" :value="county">{{county.name}}</option>
                            </select>
                        </div>
                    </div>
                    <div>
                        <div class="form-check ml-0 pl-0">
                            <label class="text-medium-blue text-18px">
                                <input type="radio" v-model="dateRange" value="all"></input>
                                <strong>{{allDatesString}}</strong>
                            </label>
                        </div>
                        <div class="form-check ml-0 pl-0">
                            <label class="text-medium-blue text-18px">
                                <input type="radio" v-model="dateRange" value="range"></input>
                                <strong>Filter Report Results by Date Range</strong>
                            </label>
                        </div>
                        <div v-if="dateRange == 'range'" class="row mt-2">
                            <div class="col-md-6">
                                <label>Start Date</label>
                                <input type="date" class="form-control" v-model="startsAt" required></input>
                            </div>
                            <div class="col-md-6">
                                <label>End Date</label>
                                <input type="date" class="form-control" v-model="endsAt" :max="dateMax" required></input>
                            </div>
                        </div>
                    </div>
                    <div v-if="assessmentReportSelected" class="mt-3 pt-2 border-top" style="z-index: 10">
                        <div class="my-2">Select Self-Assessment Data</div>
                        <div class="form-check ml-0 pl-0">
                            <label class="text-medium-blue text-18px">
                                <input type="radio" v-model="onlyLastAssessment" value="1"></input>
                                <strong>Only most recent Self-Assessment for each provider</strong>
                            </label>
                        </div>
                        <div class="form-check ml-0 pl-0">
                            <label class="text-medium-blue text-18px">
                                <input type="radio" v-model="onlyLastAssessment" value="0"></input>
                                <strong>All Self-Assessment data for each provider</strong>
                            </label>
                        </div>                        
                    </div>
                </template>
                <template #summary>
                    <div v-if="selectedState.id">State: {{ selectedState.name }}</div>
                    <div v-if="selectedCounty.id">County: {{ selectedCounty.name }}</div>
                    <div v-if="selectedProgram.id">Childcare Program: {{ selectedProgram.name}}</div>
                    <div v-if="dateRangeString">{{ dateRangeString }}</div>
                    <div v-if="assessmentReportSelected">
                        Self Assessment Data: 
                        <span v-show="onlyLastAssessment == 0">All Self-Assessment data for each provider</span>
                        <span v-show="onlyLastAssessment == 1">Only most recent Self-Assessment for each provider</span>
                    </div>
                </template>
            </form-step>
            <form-step class="report-form-step border-top border-white" v-on:previous="selectStep(2)" :nextButton="false" :step-state="steps[3]">
                <template #title>3. Run Report</template>
                <template #content>
                    <div class="text-center mx-5 mt-4">
                        <div class="mb-3 run-ready">
                            You're ready to run your report, once it's ready it will automatically download and save to your Report Archive.
                        </div>
                        <form action="reports" method="POST">
                            <input type="hidden" name="_token" :value="token"></input>
                            <input type="hidden" name="report_type_id" :value="report_type_id"></input>
                            <input type="hidden" name="starts_at" :value="startsAtString"></input>
                            <input type="hidden" name="ends_at" :value="endsAtString"></input>
                            <input type="hidden" name="program_id" :value="selectedProgram.id"></input>
                            <input type="hidden" name="only_last_assessment" :value="onlyLastAssessment"></input>
                            <input type="hidden" name="state_id" :value="(selectedState.id == 0) ? null : selectedState.id"></input>
                            <input type="hidden" name="county_id" :value="selectedCounty.id"></input>
                            <button type="submit" class="btn btn-orange-blue" style="width: 180px">Run Report</button>
                        </form>
                        <form action="reports/data" method="POST" v-if="auth.is('super-user')">
                            <input type="hidden" name="_token" :value="token"></input>
                            <input type="hidden" name="report_type_id" :value="report_type_id"></input>
                            <input type="hidden" name="starts_at" :value="startsAtString"></input>
                            <input type="hidden" name="ends_at" :value="endsAtString"></input>
                            <input type="hidden" name="program_id" :value="selectedProgram.id"></input>
                            <input type="hidden" name="only_last_assessment" :value="onlyLastAssessment"></input>
                            <input type="hidden" name="state_id" :value="(selectedState.id == 0) ? null : selectedState.id"></input>
                            <input type="hidden" name="county_id" :value="selectedCounty.id"></input>
                            <button type="submit">
                                Get Data
                            </button>
                        </form>
                        <div class="mt-5 run-instructions">
                            Each report is generated as a comma separated values (CSV) file. The file can be opened in Excel or a spreadsheet software program of your choice. Please make sure to save the file on your computer in the format you prefer.
                        </div>
                    </div>
                </template>
            </form-step>
        </div>
    </div>
</template>

<script>
    import FormStep from './FormStep'
    import BootstrapDatePicker from '../BootstrapDatePicker'
    import Auth from '../../auth'
    import moment from 'moment';
    
    export default {
        props: {
            reportTypes: {
                required: true,
                type: Array
            },
        },
        components: {
            FormStep,
            // DateSelector
            BootstrapDatePicker
        },
        data() {
            return {
                activeStep: 1,
                report_type_id: null,
                dateRange: null,
                startsAt: null,
                endsAt: null,
                selectedProgram: {},
                onlyLastAssessment: null,
                selectedState: {},
                selectedCounty: {},
                states: [],
                counties: [],
                token: document.head.querySelector('meta[name="csrf-token"]').content,
                auth: window.Auth
            }
        },
        computed: {
            startsAtString: function() {
                console.log(this.startsAt);
                if (this.startsAt !== null) {
                    return moment(this.startsAt).format('YYYY-MM-DD')
                }
                return null;
            },
            endsAtString: function() {
                if (this.endsAt !== null) {
                    return moment(this.endsAt).format('YYYY-MM-DD')
                }
                return null
            },
            typeStep: function () {
                return {
                    completed: (this.report_type_id !== null),
                    active: (this.activeStep == 1)
                };
            },
            optionsStep: function () {
                let completed = false;
                if (this.dateRange == 'all' || (this.dateRange == 'range' && this.startsAt !== null && this.endsAt !== null)) {
                    completed = true;
                }
                return {
                    completed: completed,
                    active: (this.activeStep == 2)
                }
            },
            steps: function () {
                return {
                    1: this.typeStep,
                    2: this.optionsStep,
                    3: {
                        completed: false,
                        active: (this.activeStep == 3)
                    }
                }
            },
            allDatesString: function () {
                return 'Include All Dates in Report'
            },
            dateRangeString: function () {
                if (this.dateRange == 'all') {
                    return this.allDatesString
                }
                if (this.dateRange == 'range' && this.startsAt !== null && this.endsAt !== null) {
                    return 'Filter Report Results by Date Range: ' + moment(this.startsAt).format('MM/DD/YY')+' - '+ moment(this.endsAt).format('MM/DD/YY')
                }
                return null;
            },
            dateMax: function() {
                return moment().format('YYYY-MM-DD');
            },
            assessmentReportSelected: function () {
                return [4,5,6,10,11,12,13].indexOf(this.report_type_id) > -1
            }
        },
        methods: {
            selectStep(stepNum) {
                console.log('selectStep('+stepNum+')');
                this.cleanData();
                this.activeStep = stepNum;
            },
            selectStepDirectly(stepNum) {
                console.log('selectStepDirectly('+stepNum+')');
                if (this.steps[stepNum].completed) {
                    this.selectStep(stepNum)
                }
            },
            goForward() {
                console.log('go forward');
                if (this.validate()) {
                    this.selectStep(this.activeStep+1)
                }
            },
            validate() {
                console.log('validate');
                switch (this.activeStep) {
                    case 1:
                        if (this.report_type_id === null) {
                            alert('Please select a report type.');
                            return false
                        }
                        return true;
                        break;
                    case 2: 
                        // if (this.auth.is('site-admin') && this.report_type_id != 3 && this.selectedState.id !== null) {
                        //     alert('Please select a state.')
                        //     return false
                        // }
                        if (this.report_type_id == 3 && !this.selectedProgram.id) {
                            alert('Please select a program.')
                            return false
                        }

                        if (this.dateRange === null) {
                            alert('Please select an option for the report date range.')
                            return false
                        } else if (this.dateRange == 'range') {
                            if (this.startsAt === null || this.endsAt === null) {
                                alert('Please select a date range.')
                                return false
                            }
                            const nowStamp = moment().unix()
                            if (moment(this.startsAt).unix() > nowStamp 
                                || moment(this.endsAt).unix() > nowStamp 
                                || moment(this.startsAt).unix() > moment(this.endsAt).unix()
                            ) {
                                alert('Please enter a date range where the start date is not after the end date and the end date is no later than today.')
                                return false
                            }
                        }

                        if (this.assessmentReportSelected && this.onlyLastAssessment === null) {
                            alert('Please choose which Self-Assessments to get data from.')
                            return false
                        }

                        return true
                    default:
                        return true;
                        break;
                }
            },
            cleanData() {
                if (this.report_type_id != 3) {
                    this.selectedProgram = {}
                } else {
                    this.selectedState = {}
                    this.selectedCounty = {}
                }

                if (! this.assessmentReportSelected) {
                    this.onlyLastAssessment = null
                }
            },
            getStates() {
                axios.get('/api/states')
                    .then((response) => {
                        this.states = response.data
                    })
                    .catch((error) => {
                        console.error(error)
                        alert('Problem retreiving states.')
                    })
            },
            getCounties() {
                console.log(this.auth.user.partner.state_id)
                axios.get('api/counties/'+this.auth.user.partner.state_id)
                    .then((response) => {
                        this.counties = response.data
                    })
                    .catch(error => {
                        console.error(error)
                        alert('There was a problem retrieving counties')
                    })
            }
        },
        mounted() {
            if (this.auth.is('site-admin') || this.auth.is('super-user')) {
                this.getStates();
            }
            if (this.auth.is('partner-user')) {
                this.getCounties();
            }
        }
    
}
</script>